export { default as overlayTemplate } from './overlay.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/overlay/templates/index.ts